<template>
  <w-flex wrap class="text-center basis-zero">
    <br />
    <div class="xs2 pa2">
      <div class="w-app">
        <w-card title="Parts" title-class="primary-dark1--bg">
          <w-checkbox 
          id="hideBekoC8" 
          v-model="hideBekoC8"
          label="Hide Beko C8"
          class="cursor-pointer"
        />
          <w-table style="margin: auto;" :headers="partsList.headers" :items="partsList.items" :mobile-breakpoint="600"
            :loading="partsList.loading" :selectable-rows="partsList.selectableRows" @row-select="logItem($event.item)">
            <template #no-data>👌 There is no data! 👌</template>
            <template #item="{ item, index, select, classes }">
              <tr @click="select">
                <td v-for="(header, i) in partsList.headers" :key="i" :style="item.style">
                  <div id="np-container">
                    <img v-if="header.key == 'id '" :src="item.imageThumbnail" style=" padding: 3px 3px 0px 3px;"
                      @click="showLargeImage(item)" />
                  </div>
                  {{ item[header.key] || '' }}
                  <div id="cart-container" v-if="header.label == 'Add To Cart' && item.cart">
                    <SvgIcon name="Cart" @click="addPartToShoppingCart(item)"></SvgIcon>
                  </div>
                  <div class="mdi mdi-checkbox-marked-circle" style="color:green"
                    v-if="header.label == 'In Stock' && item.inStock == 'true'"></div>
                  <div class="mdi mdi-close-circle" style="color:red"
                    v-if="header.label == 'In Stock' && item.inStock == 'false'"></div>
                  <div class="mdi mdi-checkbox-marked-circle" style="color:green"
                    v-if="header.label == 'Special Order' && item.specialOrder == true"></div>
                  <div class="mdi mdi-close-circle" style="color:red"
                    v-if="header.label == 'Special Order' && item.specialOrder == 'false'"></div>
                  <div v-if="header.label == 'Special Order' && item.specialOrderTwoWeeks == true">Under Two Weeks
                  </div>
                  <div class="mdi mdi-checkbox-marked-circle" style="color:green"
                    v-if="header.label == 'Obsolete' && item.obsolete == true"></div>
                  <div class="mdi mdi-close-circle" style="color:red"
                    v-if="header.label == 'Obsolete' && item.obsolete == 'false'"></div>
                </td>
              </tr>
            </template>
          </w-table>
        </w-card>
      </div>
    </div>
    <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width"
      :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation"
      title-class="primary-light1--bg white">
      <template #title>
        <w-icon class="mr2">mdi mdi-tune</w-icon>View File
      </template>
      <div style=" overflow-y: scroll; height: 90vh;">

        <img style="height:100%" v-if="imageFile.src != ''" v-for="image in imageFile.src" :src="image">


      </div>
      <template #actions>
        <div class="spacer"></div>
        <w-button bg-color="warning" @click="dialog.show = false">Close</w-button>
      </template>
    </w-dialog>


  </w-flex>
</template>


<script>


import { getAltParts, getASWOAlternativesFromID, getASWOPartsFromPart, getConnectItemFromManufatureCode, getConnectItemFromID, getConnectItemFromIDImages, getASWOPics, getCPartFromServiceNet } from '../components/Wrapper';
import { ref } from 'vue'
import { usePartStore } from '../store/part'
import { aswoToPart, connectToPart } from '../models/partConverter'
import SvgIcon from '../components/SvgIcon.vue';
import { useCartStore } from "../store/cart";
import { useWarehouseStore } from '../store/warehouse'


export default {
  name: "Parts", components: {
    SvgIcon
  }, activated() {

    const searchState = usePartStore().getPart()

    if (searchState !== this.part) {
      this.getPartsDetails(searchState)
      this.part = searchState
    }


  },

 

  mounted() {
    this.parts = usePartStore().getPart()
  },

  data() {
    const partDetailsRef = ref()
    const aswoAltRef = ref({})
    const connectPartFromManRef = ref({})
    const fullListOfPartsRef = ref({})
    let partsList = ref({
      headers: [
        { label: " ", key: "id ", align: "center" },
        { label: "Part Number", key: "partNumber", align: "center" },
        { label: "Part Alternative", key: "alternative", align: "center" },
        { label: "Description", key: "description", align: "center" },
        { label: "Manufacture Code", key: "manufactureCode", align: "center" },
        { label: "Brand", key: "brand", align: "center" },
        { label: "Price", key: "unitPrice", align: "center" },
        // { label: "FullPrice", key: "fullPrice", align: "center" },
        { label: "Obsolete", key: "obsoletes", align: "center" },
        { label: "Special Order", key: "specialOrders", align: "center" },
        { label: "In Stock", key: "inStocks", align: "center" },
        // { label: "imageThumbnail", key: "imageThumbnail", align: "center" },
        // { label: "image", key: "image", align: "center" },
        { label: "Peterborough Stock", key: "warehouseStock", align: "center" },
        { label: "Supplier", key: "supplierName", align: "center" },
        { label: "Add To Cart", key: "carts", align: "center" },
        // { label: "Sort Order", key: "sortOrder", align: "center" },
      ],
      selectableRows: true,
      selectionInfo: {},
      items: [],
      loading: false,

    });
    const dialog = ref({
      show: false,
      fullscreen: true,
      persistent: false,
      persistentNoAnimation: false,
      width: 800,
      height: 800
    });
    const imageFile = ref({
      src: '',
    })

    const sortByMultipleProperties = (arr, ...properties) => {
      return arr.sort((a, b) => {
        for (let i = 0; i < properties.length; i++) {
          const [prop, order] = properties[i].split(' ');
          if (a[prop] > b[prop]) {
            return order === 'asc' ? 1 : -1;
          }
          if (a[prop] < b[prop]) {
            return order === 'asc' ? -1 : 1;
          }
          // If values are equal, compare next criterion
          continue;
        }
        // If all criteria are equal, return 0
        return 0;
      });
    }
    const hideBekoC8 = ref(false)
   
    const part = usePartStore().getPart()
    const warehouseList = useWarehouseStore().getWarehouse()
    async function getPartsDetails(parts) {

      const promiseList = []

      partsList.value.loading = true;
      // console.log("Part", parts);

      if (parts.supplier.name == "ASWO") {
        // promiseList.push(getAltParts(parts))
        promiseList.push(getASWOAlternativesFromID(parts.id))
        promiseList.push(getConnectItemFromManufatureCode(parts.manufactureCode))

        Promise.all(promiseList).then(values => {

          // const [partDetails, aswoAltParts, connectPartsFromMan] = values
          const [aswoAltParts, connectPartsFromMan] = values

          // partDetailsRef.value = partDetails
          // // console.log(partDetails);
          // const altPart = partDetails != "" ? {
          //   partNumber: partDetails,
          //   manufactureCode: parts.partNumber,
          //   brand: parts.brand,
          //   description: parts.description,
          //   imageThumbnail: parts.imageThumbnail,
          //   unitPrice: 0,
          //   fullPrice: 0,
          //   obsolete: parts.obsolete,
          //   specialOrder: parts.specialOrder,
          //   inStock: parts.instock,
          //   warehouseStock: 1,
          //   style: partDetails.startsWith("C") ? { "background-color": "orange" } : partDetails.startsWith("D") ? { "background-color": "lightblue" } : {}
          // } : {}
          const aswoAlt = Object.keys(aswoAltParts).map(key => {
            const part = aswoToPart(aswoAltParts[key])

            return part
          })
          aswoAltRef.value = aswoAlt
          const connectParts = connectPartsFromMan.items ? connectPartsFromMan.items.map(connect => connectToPart(connect)) : ""
          connectPartFromManRef.value = connectParts

          // const fullListOfParts = [...[altPart], ...[parts], ...aswoAlt, ...connectParts]
          const fullListOfParts = [...[parts], ...aswoAlt, ...connectParts]

          const soredList = sortByMultipleProperties(fullListOfParts, 'obsolete asc', 'inStock desc', 'unitPrice asc');
          fullListOfPartsRef.value = soredList


          partsList.value.loading = true;
          soredList[0].cart = true
          partsList.value.items = soredList
          const altPromise = Promise.all(soredList.map(async (part) => {
            part.alternative = hideBekoC8.value?await getAltParts(part):await getCPartFromServiceNet(part)
            console.log(part,"Show beko part");

            if (part.alternative.startsWith("C")) {
              part.obsolete = false
              // partsList.value.items.unshift(part)
              part.style = { "background-color": "orange" }
              // if (!part.obsolete) {
              part.cart = true
              if (part.alternative.startsWith("C008") || part.alternative.startsWith("C009")) {
                part.sortOrder = 1
              } else {
                part.sortOrder = 2
              }
              // }
            }
            else if (part.alternative.startsWith("D1")) {
              part.style = { "background-color": "lightblue" }
              const warehouse = warehouseList.find(dnumber => dnumber.DNumber == part.alternative)
              if (warehouse != undefined) {
                console.log(warehouse);
                part.warehouseStock = warehouse.Qty
                part.supplierName = "Whirlpool"
                part.cart = true
                part.sortOrder = 1
              }

            }
            else { part.alternative = "D9999999" }
            return part
          }))
          altPromise.then(parts => {
            partsList.value.items = sortByMultipleProperties(parts, 'sortOrder asc', 'obsolete asc', 'inStock desc', 'unitPrice asc');
            partsList.value.loading = false;

          })

        })

      }
      if (parts.supplier.name == "Connect") {
        // promiseList.push(getAltParts(parts))
        promiseList.push(getASWOPartsFromPart(parts.manufactureCode))
        promiseList.push(getConnectItemFromID(parts.id))
        promiseList.push(getConnectItemFromManufatureCode(parts.manufactureCode))
        Promise.all(promiseList).then(async values => {
          // console.log("Values", values);
          // const [partDetails, aswoAltParts, connectPartsFromID, connectPartsFromMan] = values
          const [aswoAltParts, connectPartsFromID, connectPartsFromMan] = values

          // const altPart = partDetails != "" ? {
          //   id: "1",
          //   partNumber: partDetails,
          //   manufactureCode: parts.partNumber,
          //   brand: parts.brand,
          //   description: parts.description,
          //   imageThumbnail: parts.imageThumbnail,
          //   unitPrice: 0,
          //   fullPrice: 0,
          //   obsolete: parts.obsolete,
          //   specialOrder: parts.specialOrder,
          //   inStock: parts.instock,
          //   warehouseStock: 1,
          //   style: partDetails.startsWith("C") ? { "background-color": "orange" } : partDetails.startsWith("D") ? { "background-color": "lightblue" } : {}
          // } : {}

          const aswoAlt = Object.keys(aswoAltParts).map(key => { return aswoAltParts[key] })
          aswoAltRef.value = aswoAlt

          const connectParts = connectPartsFromID ? connectPartsFromID : []
          const connectPartsMan = connectPartsFromMan.items ? connectPartsFromMan.items.map(connect => connectToPart(connect)) : ""
          connectPartFromManRef.value = connectParts

          // const fullListOfParts = [...[altPart], ...[parts], ...aswoAlt, ...connectParts, ...connectPartsMan]//connectManParts
          const fullListOfParts = [...[parts], ...aswoAlt, ...connectParts, ...connectPartsMan]//connectManParts

          const soredList = sortByMultipleProperties(fullListOfParts, 'obsolete asc', 'inStock desc', 'unitPrice asc', 'warehouseStock asc');
          // fullListOfPartsRef.value = soredList.map(async (part) => {
          //   part.alternative = await getAltParts(part)
          //   return part
          // })
          soredList[0].cart = true
          const partsSet = deduplicate(soredList)
          partsList.value.loading = true;
          partsList.value.items = partsSet
          console.log(partsSet);

          const altPromise = Promise.all(partsSet.map(async (part) => {
            part.alternative = hideBekoC8.value?await getAltParts(part):await getCPartFromServiceNet(part)
            if (part.alternative.startsWith("C")) {
              part.obsolete = false
              part.style = { "background-color": "orange" }
              // if (!part.obsolete) {
              part.cart = true
              if (part.alternative.startsWith("C008") || part.alternative.startsWith("C009")) {
                part.sortOrder = 1
              } else {
                part.sortOrder = 2
              }
            }
            if (part.alternative.startsWith("D1")) {
              part.style = { "background-color": "lightblue" }
              if (warehouseList) {
                const warehouse = warehouseList.find(dnumber => dnumber.DNumber == part.alternative)
                if (warehouse != undefined) {
                  console.log(warehouse);
                  part.warehouseStock = warehouse.Qty
                  part.supplierName = "Whirlpool"
                  part.cart = true
                  part.sortOrder = 1
                }
              }
            }
            return part
          }))
          altPromise.then(parts => {
            partsList.value.items = sortByMultipleProperties(parts, 'sortOrder asc', 'obsolete asc', 'inStock desc', 'unitPrice asc');
            partsList.value.loading = false;

          })

        })
      }
    }
    getPartsDetails(part)
    function addPartToShoppingCart(part) {
      console.log(part);
      if (part.alternative == "") {
        part.description += " Needs D+8 Creation"
        part.alternative = part.partNumber
      }
      useCartStore().addItem(part)

    }
    function showLargeImage(item) {
      if (item.supplierName == "Connect") {
        getConnectItemFromIDImages(item.id).then(item => {
          console.log(item)
          if (item.images.length > 1) {
            imageFile.value.src = item.images
          }
        })
      }
      if (item.supplierName == "ASWO") {
        getASWOPics(item.id).then(item => {
          blobToBase64(item).then(img => {
            imageFile.value.src = [img]
          })
        })

      }
      imageFile.value.src = [item.image]
      dialog.value.show = true

    }

    const blobToBase64 = blob => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      return new Promise(resolve => {
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
    };
    function deduplicate(data) {
      var resArr = [];
      data.filter(function (item) {
        var i = resArr.findIndex(x => (x.id == item.id && x.partNumber == item.partNumber && x.description == item.description));
        if (i <= -1) {
          resArr.push(item);
        }
        return null;
      });
      return resArr;
    }
    function logItem(item) {
      console.log(item)
    }

    return {
      partsList,
      hideBekoC8,
      partDetailsRef,
      aswoAltRef,
      connectPartFromManRef,
      fullListOfPartsRef,
      getPartsDetails,
      part,
      addPartToShoppingCart,
      showLargeImage,
      dialog,
      imageFile,
      logItem
    }
  },
  watch: {
    hideBekoC8(newValue) {
     
        // You can trigger a page reload here
       this.getPartsDetails(this.part)
      
    }
  }
}

</script>
<style scoped>
#np-container {
  display: inline-block;
  /* border: 1px solid black; */
  overflow: hidden;
}

#np-container img {
  display: block;
  transition: transform 0.5s;
}

#np-container:hover img {
  transform: scale(1.3);
  transform-origin: 50% 50%;
}

#cart-container {
  display: inline-block;
  /* border: 1px solid black; */
  overflow: hidden;
  padding: 50px;
}

#cart-container svg {
  display: block;
  transition: transform 0.5s;
}

#cart-container:hover svg {
  transform: scale(1.3);
  transform-origin: 50% 50%;
}



.w-app .primary-dark1--bg {
  background-color: #001f59;
}

.w-app .primary--bg,
.w-app .primary-dark1--bg,
.w-app .primary-dark2--bg,
.w-app .primary-dark3--bg {
  color: #fff;
}

.c_number {
  background-color: #d4b608;
}

.d_number {
  background-color: #264497;
}
</style>